module.exports = __webpack_public_path__ + "static/media/odf.3e3493dc.png";